module.exports = __webpack_public_path__ + "static/amphisbaena-2d15699fd9d9b2719edeb4a70a8bbc3a.jpeg";